import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Snackbar,
  Alert,
  Grid,
} from "@mui/material";
import httpRequest from "../utils/httpRequest";
import HSNWiseReportCard from "./HSNWiseReportCard";
import InvoiceReportCard from './InvoiceReportCard';
import KachchaInvoiceReportCard from './KachchaInvoiceReportCard';
import CustomerRecoveryReportCard from './CustomerRecoveryReportCard';

const Reporting = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [financialYears, setFinancialYears] = useState([]);
  const [firms, setFirms] = useState([]);

  const fetchFirms = async () => {
    try {
      const data = await httpRequest("firm/getAll", "GET");
      setFirms(data);
    } catch (err) {
      console.log("Failed to fetch firm data");
    } finally {
    }
  };

  useEffect(() => {
    fetchFirms();
    let mounted = true;
    httpRequest("invoice/getAllFinancialYears", "GET").then((res) => {
      if (mounted) setFinancialYears(res || []);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Container sx={{ mt: 4 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h4" gutterBottom>
          Reporting
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <HSNWiseReportCard
            financialYears={financialYears}
            onSnackbar={setSnackbar}
            firms={firms}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <InvoiceReportCard
            financialYears={financialYears}
            onSnackbar={setSnackbar}
            firms={firms}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <KachchaInvoiceReportCard
            financialYears={financialYears}
            onSnackbar={setSnackbar}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <CustomerRecoveryReportCard
            financialYears={financialYears}
            onSnackbar={setSnackbar}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Reporting;